import { useSyncExternalStore } from 'react';

const noop = () => {};

function getSnapshot(): boolean | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return navigator.onLine;
}

function subscribe(onStoreChange: () => void): () => void {
  if (typeof window !== 'undefined') {
    globalThis.addEventListener('online', onStoreChange);
    globalThis.addEventListener('offline', onStoreChange);
    return () => {
      globalThis.removeEventListener('online', onStoreChange);
      globalThis.removeEventListener('offline', onStoreChange);
    };
  }

  return noop;
}

export function useOnline(): boolean | null {
  const isOnline = useSyncExternalStore<boolean | null>(subscribe, getSnapshot);

  return isOnline;
}
